// Shared PWA install store — captures the install prompt once and lets any
// component (floating banner, footer link) trigger it.
let deferred = null;
const subscribers = new Set();

function notify() {
  subscribers.forEach((fn) => fn(deferred));
}

if (typeof window !== "undefined") {
  window.addEventListener("beforeinstallprompt", (e) => {
    e.preventDefault();
    deferred = e;
    notify();
  });
  window.addEventListener("appinstalled", () => {
    deferred = null;
    notify();
  });
}

export function subscribeInstall(fn) {
  subscribers.add(fn);
  fn(deferred);
  return () => subscribers.delete(fn);
}

export function canInstall() {
  return !!deferred;
}

export function isStandalone() {
  if (typeof window === "undefined") return false;
  return window.matchMedia?.("(display-mode: standalone)").matches || window.navigator.standalone === true;
}

export function isIOS() {
  if (typeof window === "undefined") return false;
  return /iphone|ipad|ipod/i.test(window.navigator.userAgent);
}

// Returns: "prompted" | "installed" | "ios" | "unavailable"
export async function triggerInstall() {
  if (deferred) {
    deferred.prompt();
    try { await deferred.userChoice; } catch { /* ignore */ }
    deferred = null;
    notify();
    return "prompted";
  }
  if (isStandalone()) return "installed";
  if (isIOS()) return "ios";
  return "unavailable";
}
